import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-services',
  imports: [],
  templateUrl: './my-services.component.html',
  styleUrl: './my-services.component.scss'
})
export class MyServicesComponent {

  constructor(private router:Router){}

  handleRoute(){
    this.router.navigate(['/dashboard/my-services/plans']);
  }
}
